import { render, staticRenderFns } from "./RFMTrackingGlobalSection.vue?vue&type=template&id=5cb6e7c8&scoped=true&"
import script from "./RFMTrackingGlobalSection.vue?vue&type=script&lang=js&"
export * from "./RFMTrackingGlobalSection.vue?vue&type=script&lang=js&"
import style0 from "./RFMTrackingGlobalSection.vue?vue&type=style&index=0&id=5cb6e7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6e7c8",
  null
  
)

export default component.exports